<template>
  <v-col lg12>
    <div
      class="text-xs-center cover"
      v-if="imageUrl && accept.includes('image')"
      v-show="!loading"
      :style="{
        backgroundImage: 'url(' + imageUrl + ')',
        backgroundSize: 'contain',
        height: '550px',
        width: '100%',
      }"
    ></div>
    <div>
      <v-text-field
        :label="computedLabel"
        @click="$refs.imageInput.click()"
        :rules="required ? requiredRule : []"
        v-model="file.name"
        prepend-icon="attach_file"
        :loading="loading"
      >
        <template v-slot:prepend>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="copyClipboard" color="primary" v-on="on">
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </template>
            <span>Скопировать ссылку {{ imageUrl }}</span>
          </v-tooltip>
        </template>
        <template v-slot:append>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn icon :href="url" target="_blank" color="primary" v-on="on">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </template>
            <span>Загрузить файл</span>
          </v-tooltip>
        </template>
      </v-text-field>
    </div>
    <input
      type="file"
      style="display: none"
      ref="imageInput"
      :accept="accept"
      :required="required ? !url : false"
      :name="fieldName"
      @change="onFilePicked"
    />
  </v-col>
</template>

<script>
export default {
  name: 'FileInput',
  // mixins: [api],
  props: {
    required: { type: Boolean, default: true },
    label: { type: String, default: 'Выберите файл' },
    fieldName: { type: String, default: 'image' },
    url: { type: String, default: '' },
    upload: { type: Boolean, default: false },
    accept: { type: String, default: 'image/*' },
  },
  data() {
    return {
      loading: false,
      progress: 0,
      file: { name: '', url: '', file: null },
      requiredRule: [(v) => !!v || 'Это поле обязательно'],
    }
  },
  computed: {
    computedLabel() {
      if (this.url) {
        return this.label + ' ' + this.url
      }
      return this.label
    },
    imageUrl() {
      return this.file.url || this.url
    },
  },
  mounted() {},
  update() {},
  methods: {
    copyClipboard() {
      const el = document.createElement('textarea')
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      el.value = this.imageUrl
      document.body.appendChild(el)
      const selected =
        document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
      // this.showSnackbar(`Ссылка ${this.doc.url} записана в буфер обмена`)
      this.showSnackbar('Скопировано ' + this.imageUrl)
    },
    uploadImage(file) {
      this.progress = 0
      let data = new FormData()
      data.append('file', file.file, file.name)
      return this.axios({
        url: '/v1/images',
        method: 'post',
        data: data,
        config: {
          headers: { 'content-type': 'multipart/form-data' },
        },
        onUploadProgress: (progressEvent) => {
          this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          this.$log.info(progressEvent)
        },
      })
    },
    onFilePicked(e) {
      let f = { name: '', url: '', file: null }
      this.$emit('file-picked')
      const files = e.target.files
      if (files[0] !== undefined) {
        f.name = files[0].name
        f.file = files[0]
        if (f.name.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          f.url = fr.result
          this.file = f
          if (this.upload) {
            this.progress = 0
            this.loading = true
            this.uploadImage(this.file)
              .then((res) => {
                this.file = res.data
                this.$emit('file-uploaded', this.file)
                this.showSnackbar('Изображение загружено', 'green')
              })
              .catch((err) => {
                this.showSnackbar('Ошибка загрузки файла ' + err.response.toString(), 'error')
              })
              .finally(() => {
                this.loading = false
              })
          }
          this.$emit('file-selected', this.file)
        })
      }
    },
  },
}
</script>
